/**************************************************
 * Nombre:       Selector_Habitacion
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import {useEffect, useState} from "react";
import {ordenarHabitacionesTorrePiso} from "../Funciones/ordenarHabitacionesTorrePiso";
import Tarjeta_Piso from "./Tarjetas/Tarjeta_Piso";
import Tarjeta_Torre from "./Tarjetas/Tarjeta_Torre";

const Selector_Habitacion = ({habitaciones, habOcupadas, seleccionada, setSeleccionada}) => {
    const [habiOrdenadas, setHabiOrdenadas] = useState([])

    useEffect(() => {

        let habis = ordenarHabitacionesTorrePiso({arrHabitaciones: habitaciones})
        setHabiOrdenadas(habis)

    }, [habitaciones]);
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            {habiOrdenadas.map((it, index) => {
                return (
                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 2}}>
                        <Tarjeta_Torre seleccionada={seleccionada} setSeleccionada={setSeleccionada} it={it}
                                      habOcupadas={habOcupadas}/>
                    </Grid>
                )
            })}

        </Grid>
    )

}
export default Selector_Habitacion